const _directiveDependencies = [];
const _controllerDependencies = ['$scope'];

class CryptoFaqController {

    constructor($scope) {

        $scope.activeQuestion = 'q1';

        $scope.changeQuestion = (question) => {

            $scope.activeQuestion = question;

        };

    }

}


class CryptoFaqDirective {

    constructor() {

        this.template = require('./crypto-faq.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push($scope =>
            new CryptoFaqController($scope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'CryptoFaqCtrl';

    }

}

_directiveDependencies.push(() => new CryptoFaqDirective());


angular.module('directives')
    .directive('cryptoFaq', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/crypto-faq/crypto-faq.js